import React, { Component } from 'react';
import idx from 'idx';
import { Form, Field, SubmissionError } from 'redux-form';
import { getClientLabel } from 'focus_groups/utils';
import { TextInputField, EmailInputField, CheckBoxField } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';
import { STAGE_DONE } from 'focus_groups/ducks/vote';
import ConfirmVoteModal from 'focus_groups/containers/confirm_vote_modal';

export default class ParticipantInfoForm extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBtnClick = this.handleBtnClick.bind(this);
  }

  handleBtnClick(e) {
    const { submittingVotes, submit, toggleConfirmVote, fetchGroup } = this.props;

    e.preventDefault();
    e.stopPropagation();

    /* if submitting votes, fetch updated group and show confirmation modal first */
    if (submittingVotes) {
      fetchGroup();
      toggleConfirmVote();
    } else {
      submit();
    }
  }

  handleSubmit(formData) {
    const { submittingVotes, setStage, toggleConfirmVote, setParticipantInfo } = this.props;

    /* if participant provide us her email, she consents in receiving project notifications */
    const data = { ...formData, receive_project_notifications: !!formData.email };

    return setParticipantInfo(data).catch((res) => {
      const error = idx(res, _ => _.data.message) || 'Failed to submit form. Please try again.';
      throw new SubmissionError({ _error: error });
    }).finally(() => {
      /* if submitting votes, always close confirmation modal and move to `STAGE_DONE` stage */
      if (submittingVotes) {
        toggleConfirmVote();
        setStage(STAGE_DONE);
      }
    })
  }

  render() {
    const {
      submitting, error, submitFailed, handleSubmit, client, shareResults,
      submittingVotes, submit, submitSucceeded
    } = this.props;

    const clientLabel = getClientLabel(client);

    let btnLabel = "Submit";
    if (submittingVotes) {
      btnLabel = "Submit my feedback" + (shareResults? " and see results" : "");
    }

    if (submitSucceeded) {
      return (
        <div className="text-center">
          <i className="fa fa-2x fa-check-circle text-success" />
          <h2>Thanks!</h2>
        </div>
      );
    }

    return (
      <div>
        <Form onSubmit={handleSubmit(this.handleSubmit)} className="participant-info-form">
          { submittingVotes &&
          <fieldset>
            <h3>Your Name</h3>
            <p>
              Your name will help {clientLabel} identify your feedback and only they
              <br className="hide-for-small-only"/> can see it.
              Leave blank if you want to be anonymous.
            </p>
            <Field name="name" label="Enter your first and last name" component={TextInputField} />
          </fieldset> }

          <fieldset>
            <h3>Your Email</h3>
            <p>
              We'll let you know when {clientLabel} picks the winner.
              <br className="hide-for-small-only" /> We won't share your email with anyone.
            </p>
            <Field name="email" label="Enter your email" component={EmailInputField} />

            <Field name="accepted_promo" component={CheckBoxField}
              label="I'd love $25 off my own design project + a free advanced promotion ($99 value)." />
          </fieldset>

          <AnimatedButton processing={submitting} onClick={this.handleBtnClick}
            baseBtnClass="btn-tertiary" label={btnLabel} processingLabel="Submitting..."
            errorMsg={error || submitFailed} successMsg="Done!" />
        </Form>
        <ConfirmVoteModal submitAction={submit} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./focus_groups/components/participant_info_form.jsx